import { Box } from '@chakra-ui/react'
import Image from 'next/image'
import Link from 'next/link'

export const Logo = (): JSX.Element => (
  <Link href="/" passHref>
    <Box hideFrom="lg">
      <Image
        loading="eager"
        src="/logo-small.svg"
        alt="Leid Logo"
        width={64}
        height={64}
        style={{ cursor: 'pointer', display: 'block', overflow: 'hidden', height: '64px' }}
      />
    </Box>
    <Box hideBelow="lg">
      <Image
        loading="eager"
        src="/logo.svg"
        alt="Leid Logo"
        width={150}
        height={64}
        style={{ cursor: 'pointer', display: 'block', maxWidth: '100px', transform: 'scale(1.5)' }}
      />
    </Box>
  </Link>
)
